export default (state, getters) => value => {
    if (!(value.rowIndex >= getters.row_min && value.rowIndex <= getters.row_max)) {
        return {};
    }
}